import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { ConfigService } from "./config.service";
import { HttpClient } from "@angular/common/http";
import { CreditCheckDetails, CreditCheckLightRequest, CreditCheckRequest, CreditCheckResponse } from "../models/credit-check";

@Injectable({
    providedIn: 'root',
})
export class CreditCheckService {

    constructor(private configService: ConfigService, private httpClient: HttpClient) {}

  public performCreditCheck(creditCheckRequestData: CreditCheckRequest): Observable<CreditCheckResponse> {

      const path = this.configService.getApiPath(`credit-check/request`);
      return this.httpClient.post<CreditCheckResponse>(path, creditCheckRequestData);

  }

  public performCreditCheckLight(creditCheckRequestData: CreditCheckLightRequest): Observable<CreditCheckResponse> {

    const path = this.configService.getApiPath(`credit-check/requestLight`);
    return this.httpClient.post<CreditCheckResponse>(path, creditCheckRequestData);

  }

    public getCreditCheckDetails(quoteRequestId: number): Observable<CreditCheckDetails> {

      const path = this.configService.getApiPath(`credit-check/${quoteRequestId}/credit-check-details`);
      const response = this.httpClient.get<CreditCheckDetails>(path);
      return response;
    }

  public approveCreditCheck(quoteRequestId: number): Observable<any> {
    
    const path = this.configService.getApiPath(`credit-check/${quoteRequestId}/approve`);
    return this.httpClient.post(path, null);
    }
}
